import { UserOverview } from './user';

export enum NoteContextEnum {
    WORKPAPER_PROCEDURE = 'WORKPAPER_PROCEDURE',
}

export type Note = {
    id: string;
    firmId: string;
    rawMessage: string;
    structuredMessage: { [key: string]: unknown };
    createdAt: Date;
    createdBy: UserOverview;
    updatedAt: Date;
    lastModifiedBy: UserOverview;
    context: { id: string; type: NoteContextEnum; label: string };
};
